import React from "react";
import { Stack } from "@mui/material";
import { PreviewItem, Label } from "../../../../components";
import { formatWithoutTimezone } from "../../../../utils/common";
import { useSelector } from "react-redux";
const HistoryItem = ({ status, type }) => {
  let label;
  let previousStatus;
  let currentStatus;
  const isMediator = useSelector(
    (state) => state.profileReducer?.user?.is_mediator
  );
  // const { text_colour, background_colour } = status.status;
  // const display =
  //   type === "outward"
  //     ? isMediator
  //       ? status?.status?.mediator_name
  //       : status?.status?.sender_name
  //     : status?.status?.receiver_name;

  // label = (
  //   <Label
  //     variant={"ghost"}
  //     textColor={text_colour}
  //     backgroundColor={background_colour}
  //     sx={{ textTransform: "capitalize" }}
  //   >
  //     {display}
  //   </Label>
  // );

  previousStatus = status?.previous_status && (
    <Label
      variant={"ghost"}
      color={
        status?.previous_status?.value === "Complete"
          ? "complete"
          : status?.previous_status?.value === "RejectedByChecker"
          ? "rejected"
          : "application submitted"
      }
      sx={{ textTransform: "capitalize" }}
    >
      {status?.previous_status?.display}
    </Label>
  );

  currentStatus = status?.current_status && (
    <Label
      variant={"ghost"}
      color={
        status?.current_status?.value === "Complete"
          ? "complete"
          : status?.current_status?.value === "RejectedByChecker"
          ? "rejected"
          : "application submitted"
      }
      sx={{ textTransform: "capitalize" }}
    >
      {status?.current_status?.display}
    </Label>
  );

  return (
    <Stack
      key={status.id}
      spacing={3}
      direction={"row"}
      sx={{
        borderRadius: "8px",
        borderColor: "#000",
        backgroundColor: "#F0F0F0",
        padding: "1rem",
        marginTop: "1.5rem",
        width: { lg: "90%", xs: "100%" },
        justifyContent: "space-between",
        overflow: "auto",
      }}
    >
      <Stack spacing={0} direction={"row"}>
        <PreviewItem
          title={" Previous Status"}
          content={previousStatus || ""}
          sx={{ minWidth: "250px" }}
        />
        <PreviewItem
          title={" Current Status"}
          content={currentStatus || ""}
          sx={{ minWidth: "250px" }}
        />
        {/* <PreviewItem title={"Remarks"} sx={{ minWidth: "200px" }} content={status?.remarks || ""} /> */}
      </Stack>
      <Stack spacing={0} direction={"row"}>
        <PreviewItem
          title={"Updated By"}
          sx={{ minWidth: "200px" }}
          content={
            status?.modified_user?.name || status?.modified_user?.email || ""
          }
        />
        <PreviewItem
          title={"Date"}
          sx={{ minWidth: "150px" }}
          content={formatWithoutTimezone(
            status?.modified_date,
            "dd MMM yyyy HH:mm a"
          )}
        />
      </Stack>
    </Stack>
  );
};

export default HistoryItem;
